export default __webpack_public_path__ + "images/slide_3.jpeg?0f2564a4e2a48a4dff69d280c16a84d6";